module.exports = __webpack_public_path__ + "static/img/newTwo.8cafb4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newTwo.png
// module id = Ce2G
// module chunks = 1